import React, { useEffect, useState } from "react";

export default function useLanguage() {
  return [window.localStorage.getItem("LANGUAGE")];
}
